/*
 * @Author: Admni
 * @Description: 
 * @Date: 2020-07-14 17:18:08
 * @LastEditTime: 2021-02-08 10:29:37
 */
const getters = {
    sidebar: state => state.app.sidebar,
    permission_routes: state => state.permission.routes,
    cur_app: state => state.app.curApp,
    cur_event: state => state.app.curEvent,
    pickerOptions: state => state.app.pickerOptions
}

export default getters
